import { getWebInstrumentations, initializeFaro } from "@grafana/faro-web-sdk";
import { logger } from "@/lib/logger";

const LOG_NAMESPACE = "GRAFANA_FARO";

type FaroConfig = Parameters<typeof initializeFaro>[0];

declare const __VITE_GRAFANA_FARO_URL__: string | undefined;

declare const __VITE_GRAFANA_FARO_APP_NAME__: string | undefined;
declare const __VITE_GRAFANA_FARO_APP_VERSION__: string | undefined;
declare const __VITE_GRAFANA_FARO_ENVIRONMENT__: string | undefined;

interface GrafanaFaroConfig {
  url: string;
  appName: string;
  appVersion: string;
  environment: string;
}

const getGrafanaFaroConfig = (): GrafanaFaroConfig | null => {
  const url = __VITE_GRAFANA_FARO_URL__;
  if (!url) {
    return null;
  }

  return {
    url,
    appName: __VITE_GRAFANA_FARO_APP_NAME__ || "money-trail-ui",
    appVersion: __VITE_GRAFANA_FARO_APP_VERSION__ || "unknown",
    environment: __VITE_GRAFANA_FARO_ENVIRONMENT__ || "development",
  };
};

export const initGrafanaFaro = (): void => {
  if (typeof window === 'undefined') {
    return;
  }

  const windowRef = window as Window & { grafanaFaro?: unknown };
  if (windowRef.grafanaFaro) {
    logger.debug(LOG_NAMESPACE, "Grafana Faro already initialized.");
    return;
  }

  const configValues = getGrafanaFaroConfig();
  if (!configValues) {
    logger.debug(LOG_NAMESPACE, "Grafana Faro disabled (missing VITE_GRAFANA_FARO_URL).");
    return;
  }

  const { url, appName, appVersion, environment } = configValues;

  const config: FaroConfig = {
    url,
    app: {
      name: appName,
      version: appVersion,
      environment,
    },
    instrumentations: getWebInstrumentations(),
  };

  const faro = initializeFaro(config);
  windowRef.grafanaFaro = faro;
  logger.debug(LOG_NAMESPACE, "Grafana Faro initialized.");
};
